import React, { useRef } from "react";
import { useLocation } from "react-router-dom";

export const PayoutSentToQc = ({
  sendToQcHandler,
  sendToQcPayload,
  setSendToQcPayload,
}) => {
  const ref = useRef();
  const location = useLocation()
  

  const handleSubmit = async () => {
    // if(location === "/payout/insurerbilling"){

    // }else{
    // }
    sendToQcHandler(ref);


  };

  return (
    <div class="modal-dialog modal-dialog-centered " role="document" >
      <div class="modal-content" style={{borderRadius:"12px"}}>
        <div class="modalHeader justify-content-between  d-flex" style={{borderTopLeftRadius:"12px",borderTopRightRadius:"12px"}}>
          <h4 className="font-bold text-black">{location?.pathname === "/insurer/insurerbilling" ? "QC Approval" : "Send To QC"}</h4>
          <button
            type="button"
            className="btn-close history-close"
            aria-label="Close"
            data-bs-dismiss="modal"
            ref={ref}
            //   onClick={handleClose}
          ></button>
        </div>
        <p className="pTagPayoutSendQc">
          Hi, Please make sure you have checked the {location?.pathname === "/insurer/insurerbilling" ? "Billing" : "Payout"} data before clicking
          on the submit button.
        </p>
        <p className="pTagPayoutSendQc">
          Once the {location?.pathname === "/insurer/insurerbilling" ? "Billing" : "Payout"} goes for QC, It can't be reversed.
        </p>
        <p className="pTagPayoutSendQc pb-2">Add remark as well if any</p>
        <textarea
          placeholder="Remarks"
          className="inputTagPayoutSendQc"
          style={{backgroundColor:"#eeeeee"}}
          value={sendToQcPayload?.remarks}
          onChange={(e) =>
            setSendToQcPayload({ ...sendToQcPayload, remarks: e.target.value })
          }
        />
        <div class="d-flex justify-content-end p-2 pe-3 ">
          {/* <button
            type="button"
            className="search"
            data-bs-dismiss="modal"
            style={{ border: "none" }}
           
          >
            <a className="sidebar-links">
              <span className="sidebar-link-text">Close</span>
            </a>
          </button> */}
          <button
            type="button"
            className="search"
            style={{ border: "none" }}
            onClick={handleSubmit}
          >
            <a className="sidebar-links">
              <span className="sidebar-link-text">Submit</span>{" "}
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};
